import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function ObjectionsSection() {
  const faqs = [{
    question: '¿Funciona para todos los niños?',
    answer: 'Esta guía ofrece opciones complementarias generales basadas en ingredientes naturales comunes y seguros. Cada niño es diferente, por lo que siempre recomendamos observar cómo reacciona tu hijo y consultar con tu pediatra ante cualquier duda.'
  }, {
    question: '¿Es complicado de seguir?',
    answer: 'No, en absoluto. Está diseñada para madres reales con poco tiempo. Los pasos son simples, directos y utilizan ingredientes que probablemente ya tienes en tu cocina o despensa.'
  }, {
    question: '¿Reemplaza al médico?',
    answer: 'No, y nunca lo pretende. PequeSalud Natural es un complemento de apoyo para el hogar. Si los síntomas son graves, persistentes o te preocupan, siempre debes consultar a un profesional de la salud.'
  }];
  return <section className="py-20 bg-white" data-id="element-207">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <h2 className="text-3xl md:text-4xl font-bold text-forest text-center mb-12" data-id="element-209">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-210">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.question} answer={faq.answer} data-id="element-211" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-sage/20 rounded-xl overflow-hidden bg-cream/30" data-id="element-212">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center p-5 text-left focus:outline-none" data-id="element-213">
        <span className="font-semibold text-forest text-lg" data-id="element-214">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-terracotta" data-id="element-215" /> : <ChevronDown className="h-5 w-5 text-forest/60" data-id="element-216" />}
      </button>
      <AnimatePresence data-id="element-217">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-218">
            <div className="px-5 pb-5 text-forest/70 leading-relaxed" data-id="element-219">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}